import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { injectIntl, intlShape } from 'react-intl';
import { Link, withRouter, routerShape } from 'react-router';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import ActiveFilterToken from '../../ActiveFilterToken';
import { getLabel } from '@bibliocommons/utils-filter';
import '../styles/LinkFilter.scss';

class LinkFilter extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('handleToggleFilter');
  }

  handleToggleFilter(e) {
    if (e) { e.preventDefault(); }
    this.props.handleToggleFilter(this.props.fieldId, this.props.filter);
  }

  render () {
    const { fieldId, filter, intl, refFunction, group } = this.props;
    const value = filter.get('value');
    const label = filter.get('label');
    const count = filter.get('count');
    const applied = filter.get('applied');

    const filterLabel = getLabel(intl, fieldId, label || value);
    const formattedLabel = intl.formatMessage({ id: 'Facets.filterLabelFormat' }, { value: filterLabel, count });
    const linkId = [fieldId, group, value].filter(v => !!v).join('-');

    if (applied) {
      return (
        <span className="cp-link-filter">
          <ActiveFilterToken filter={filter} handleToggleFilter={this.props.handleToggleFilter} fieldId={fieldId} filterLabel={filterLabel} ref={refFunction} />
        </span>
      );
    }

    return (
      <Link
        className="cp-link-filter"
        data-test-id={`${linkId}-filter`}
        onClick={this.handleToggleFilter}
        ref={refFunction}
        href={`#filter-${fieldId}-${value}`}>
        {formattedLabel}
      </Link>
    );
  }
}
LinkFilter.propTypes = {
  group: PropTypes.string,
  filter: ImmutablePropTypes.map.isRequired,
  fieldId: PropTypes.string.isRequired,
  handleToggleFilter: PropTypes.func.isRequired,
  router: routerShape,
  intl: intlShape,
  refFunction: PropTypes.func
};

LinkFilter.defaultProps = {
  group: ''
};

export default injectIntl(withRouter(LinkFilter));



// WEBPACK FOOTER //
// ./app/components/shared/Facets/LinkFilter/components/LinkFilter.component.jsx